import React, { useEffect, useState } from 'react';
import { Clock, Users } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [spotsLeft, setSpotsLeft] = useState(200);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    // Simulate spots decreasing
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev > 12) {
          return prev - Math.floor(Math.random() * 3);
        }
        return prev;
      });
    }, 8000);
    return () => {
      clearInterval(timer);
      clearInterval(spotsTimer);
    };
  }, []);
  const totalSpots = 200;
  const percentage = spotsLeft / totalSpots * 100;
  return <div className="bg-black/60 backdrop-blur-md rounded-xl p-5 border border-tennis-yellow/30 text-white my-6" data-id="element-77">
      <div className="flex flex-col items-center mb-4" data-id="element-78">
        <div className="flex items-center gap-2 text-tennis-yellow mb-2" data-id="element-79">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-80" />
          <span className="font-bold text-lg uppercase tracking-wider" data-id="element-81">
            Oferta por tiempo limitado
          </span>
        </div>
        <div className="flex gap-3 text-center" data-id="element-82">
          <div className="bg-black/80 rounded-lg px-4 py-2 min-w-[70px] border border-white/10" data-id="element-83">
            <span className="text-3xl font-black block" data-id="element-84">
              {String(timeLeft.minutes).padStart(2, '0')}
            </span>
            <span className="text-xs text-gray-400 uppercase" data-id="element-85">Min</span>
          </div>
          <div className="text-3xl font-black py-2" data-id="element-86">:</div>
          <div className="bg-black/80 rounded-lg px-4 py-2 min-w-[70px] border border-white/10" data-id="element-87">
            <span className="text-3xl font-black block" data-id="element-88">
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
            <span className="text-xs text-gray-400 uppercase" data-id="element-89">Seg</span>
          </div>
        </div>
      </div>

      <div className="mt-5" data-id="element-90">
        <div className="flex justify-between text-sm mb-2 font-medium" data-id="element-91">
          <span className="flex items-center gap-1 text-red-400" data-id="element-92">
            <Users className="w-4 h-4" data-id="element-93" />
            Cupos restantes
          </span>
          <span className="text-white font-bold" data-id="element-94">
            {spotsLeft} / {totalSpots}
          </span>
        </div>
        <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden border border-white/10" data-id="element-95">
          <div className="bg-gradient-to-r from-red-500 to-tennis-yellow h-3 rounded-full transition-all duration-1000" style={{
          width: `${percentage}%`
        }} data-id="element-96"></div>
        </div>
        <p className="text-center text-xs text-gray-400 mt-2" data-id="element-97">
          Más de 850 personas ya están entrenando con este sistema
        </p>
      </div>
    </div>;
}